var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 10,
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1364_9953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4563 36.6665H12.5438C12.2434 36.6665 12 36.937 12 37.2707V40.8957C12 41.2293 12.2434 41.4998 12.5438 41.4998H40.4563C40.7566 41.4998 41 41.2293 41 40.8957V37.2707C41 36.937 40.7566 36.6665 40.4563 36.6665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.698 22.7306L23.339 14.1594C24.151 13.1122 25.253 12.5322 26.5 12.5C27.6745 12.5 28.82 13.0961 29.6465 14.1594L36.302 22.7306C36.6645 23.1978 36.7515 23.8744 36.5195 24.4544C36.2875 25.0183 35.7655 25.3889 35.2 25.3889H17.8C17.2345 25.3889 16.7125 25.0183 16.4805 24.4544C16.2485 23.8744 16.3355 23.1978 16.698 22.7306Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.325 35.0557H28.675C29.0754 35.0557 29.4 34.695 29.4 34.2501L29.4 16.5279C29.4 16.083 29.0754 15.7223 28.675 15.7223H24.325C23.9246 15.7223 23.6 16.083 23.6 16.5279V34.2501C23.6 34.695 23.9246 35.0557 24.325 35.0557Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1364_9953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(12 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacArrowUp);
export default __webpack_public_path__ + "static/media/contac_arrow_up.88e6b52db16d3bc6a341fec3ac9d757f.svg";
export { ForwardRef as ReactComponent };